import THREE from 'particlespace-graphics-engine'
import {colorCoding} from '../../../core/controllers/ColorCoding'

import roomRenderer from '../controllers/RoomRenderer'

var SensorRenderer = Class.create({
  	initialize: function() {
		// setup our local vars
		// default is single room type
		var divideScalar = 25;
		var multiplyScalar = 25;
		var addScalar = 25;
		var additionalZ = 0;
		var additionalX = 0;
		this.additionalZ = additionalZ;
		this.additionalX = additionalX;
		this.roomID = 1;
		this.roomType = 'watersensor';
		this.size = 49
		this.divideScalar = divideScalar;
		this.multiplyScalar = multiplyScalar;
		this.addScalar = addScalar;
		this.roomRenderer = roomRenderer;
		this.isActive = false;
		this.isSensor = true;
		this.floodSensorNormal;
		this.doorSensorNormal;
		this.fireSensorNormal;
		this.tempSensorNormal;
		this.floodSensorHover;
		this.doorSensorHover;
		this.fireSensorHover;
		this.tempSensorHover;
		this.doorSensorAlert;
		this.fireSensorAlert;
		this.floodSensorAlert;
		var self = this;
		this.loadAssets(function() {
			self.initFirstTime();
		});
  	},
	updateSensorType: function(domID)
	{
		if(this.roomRenderer) {
			this.roomRenderer.isActive = false;
		}

		this.isActive = true;

        if(domID == 'watersensor')
		{
			var divideScalar = 25;
			var multiplyScalar = 25;
			var addScalar = 25;
			var additionalZ = 25;
			var additionalX = 25;
			var cubeGeometry = new THREE.PlaneBufferGeometry(25, 25);
			var cubeMaterial = new THREE.MeshBasicMaterial( { map: this.floodSensorNormal, side:THREE.DoubleSide, opacity: 1} ); // moving to roomObj

			var cubeTmpHoverMaterial = new THREE.MeshBasicMaterial({ map: this.floodSensorHover, transparent: true, overdraw: 0, opacity: 0.5, side:THREE.DoubleSide});// used to give a transparency to the cube tmp view // moving to roomObj
			this.divideScalar = divideScalar;
			this.multiplyScalar = multiplyScalar;
			this.addScalar = addScalar;

			this.additionalZ = additionalZ;
			this.additionalX = additionalX;
			this.roomID = 1;
			this.roomType = 'watersensor';
			this.size = 99
			this.cubeGeometry = cubeGeometry;
			this.cubeMaterial = cubeMaterial;
			this.cubeTmpHoverMaterial = cubeTmpHoverMaterial;
			this.colorNormal = this.floodSensorNormal;
			this.colorHover = this.floodSensorHover;
			this.colorAlert = this.floodSensorAlert;
		} else if(domID == 'doorsensor') {
			var divideScalar = 25;
			var multiplyScalar = 25;
			var addScalar = 25;
			var additionalZ = 25;
			var additionalX = 25;
			var cubeGeometry = new THREE.PlaneBufferGeometry(25, 25);
			var cubeMaterial = new THREE.MeshBasicMaterial( { map: this.doorSensorNormal, side:THREE.DoubleSide, opacity: 1} ); // moving to roomObj

			var cubeTmpHoverMaterial = new THREE.MeshBasicMaterial({ map: this.doorSensorHover, transparent: true, overdraw: 0, opacity: 0.5, side:THREE.DoubleSide});// used to give a transparency to the cube tmp view // moving to roomObj
			this.divideScalar = divideScalar;
			this.multiplyScalar = multiplyScalar;
			this.addScalar = addScalar;

			this.additionalZ = additionalZ;
			this.additionalX = additionalX;
			this.roomID = 1;
			this.roomType = 'doorsensor';
			this.size = 99
			this.cubeGeometry = cubeGeometry;
			this.cubeMaterial = cubeMaterial;
			this.cubeTmpHoverMaterial = cubeTmpHoverMaterial;
			this.colorNormal = this.doorSensorNormal;
			this.colorHover = this.doorSensorHover;
			this.colorAlert = this.doorSensorAlert;
		} else if(domID == 'firealarm') {
			var divideScalar = 25;
			var multiplyScalar = 25;
			var addScalar = 25;
			var additionalZ = 25;
			var additionalX = 25;
			var cubeGeometry = new THREE.PlaneBufferGeometry(25, 25);
			var cubeMaterial = new THREE.MeshBasicMaterial( { map: this.fireSensorNormal, side:THREE.DoubleSide, opacity: 1} ); // moving to roomObj
			var cubeTmpHoverMaterial = new THREE.MeshBasicMaterial({ map: this.fireSensorHover, transparent: true, overdraw: 0, opacity: 0.5, side:THREE.DoubleSide});// used to give a transparency to the cube tmp view // moving to roomObj
			this.divideScalar = divideScalar;
			this.multiplyScalar = multiplyScalar;
			this.addScalar = addScalar;

			this.additionalZ = additionalZ;
			this.additionalX = additionalX;
			this.roomID = 1;
			this.roomType = 'firealarm';
			this.size = 99
			this.cubeGeometry = cubeGeometry;
			this.cubeMaterial = cubeMaterial;
			this.cubeTmpHoverMaterial = cubeTmpHoverMaterial;
			this.colorNormal = this.fireSensorNormal;
			this.colorHover = this.fireSensorHover;
			this.colorAlert = this.fireSensorAlert;
		} else if(domID == 'tempsensor') {
			var divideScalar = 25;
			var multiplyScalar = 25;
			var addScalar = 25;
			var additionalZ = 25;
			var additionalX = 25;
			var cubeGeometry = new THREE.PlaneBufferGeometry(25, 25);
			var cubeMaterial = new THREE.MeshBasicMaterial( { map: this.tempSensorNormal, side:THREE.DoubleSide, opacity: 1} ); // moving to roomObj
			var cubeTmpHoverMaterial = new THREE.MeshBasicMaterial({ map: this.tempSensorHover, transparent: true, overdraw: 0, opacity: 0.5, side:THREE.DoubleSide});// used to give a transparency to the cube tmp view // moving to roomObj
			this.divideScalar = divideScalar;
			this.multiplyScalar = multiplyScalar;
			this.addScalar = addScalar;

			this.additionalZ = additionalZ;
			this.additionalX = additionalX;
			this.roomID = 1;
			this.roomType = 'tempsensor';
			this.size = 99
			this.cubeGeometry = cubeGeometry;
			this.cubeMaterial = cubeMaterial;
			this.cubeTmpHoverMaterial = cubeTmpHoverMaterial;
			this.colorNormal = this.tempSensorNormal;
			this.colorHover = this.tempSensorHover;
		}
	},
	initFirstTime: function() {
		var divideScalar = 25;
		var multiplyScalar = 25;
		var addScalar = 25;
		var additionalZ = 25;
		var additionalX = 25;
		var cubeGeometry = new THREE.PlaneBufferGeometry(25, 25);
		var cubeMaterial = new THREE.MeshBasicMaterial( { map: this.colorNormal, side:THREE.DoubleSide, opacity: 1} ); // moving to roomObj

		var cubeTmpHoverMaterial = new THREE.MeshBasicMaterial({ map: this.colorHover, transparent: true, overdraw: 0, opacity: 0.5, side:THREE.DoubleSide});// used to give a transparency to the cube tmp view // moving to roomObj
		this.divideScalar = divideScalar;
		this.multiplyScalar = multiplyScalar;
		this.addScalar = addScalar;

		this.additionalZ = additionalZ;
		this.additionalX = additionalX;
		this.roomID = 1;
		this.roomType = 'watersensor';
		this.size = 99
		this.cubeGeometry = cubeGeometry;
		this.cubeMaterial = cubeMaterial;
		this.cubeTmpHoverMaterial = cubeTmpHoverMaterial;
	},
	// #  Gets our geometry based on abbreviation type
	getGeometry: function(domID)
	{
		var cubeGeometry;
		cubeGeometry = new THREE.PlaneBufferGeometry(25, 25);
		return cubeGeometry;
	},
	// #  Gets our material based on abbreviation type
	getMaterial: function(domID, callback)
	{
		var self = this;
		this.loadAssets(function() {
			if(domID == 'watersensor') {
				var cubeMaterial = new THREE.MeshBasicMaterial( { map: self.colorNormal, side:THREE.DoubleSide, opacity: 1, overdraw: 0} );
				callback(cubeMaterial, self.floodSensorNormal, self.floodSensorHover, self.floodSensorAlert);
			} else if(domID == 'doorsensor') {
				var cubeMaterial = new THREE.MeshBasicMaterial( { map: self.doorSensorNormal, side:THREE.DoubleSide, opacity: 1, overdraw: 0} );
				callback(cubeMaterial, self.doorSensorNormal, self.doorSensorHover, self.doorSensorAlert);
			} else if(domID == 'firealarm') {
				var cubeMaterial = new THREE.MeshBasicMaterial( { map: self.fireSensorNormal, side:THREE.DoubleSide, opacity: 1, overdraw: 0} );
				callback(cubeMaterial, self.fireSensorNormal, self.fireSensorHover, self.fireSensorAlert);
			} else if(domID == 'tempsensor') {
				var cubeMaterial = new THREE.MeshBasicMaterial( { map: self.tempSensorNormal, side:THREE.DoubleSide, opacity: 1, overdraw: 0} );
				callback(cubeMaterial, self.tempSensorNormal, self.tempSensorHover);
			}
		});
	},
	// #  Gets our room id based on abbreviation type
	getRoomID: function(domID)
	{
		var roomID;
		if(domID == 'watersensor')
		{
			roomID = 1
		} else if(domID == 'doorsensor') {
			roomID = 2
		} else if(domID == 'firealarm') {
			roomID = 3
		} else if(domID == 'tempsensor') {
			roomID = 4
		}

		return roomID;
	},
	getDivideScalar : function(domID)
	{
		var divideScalar;
		divideScalar = 25;

		return divideScalar;
	},
	getMultiplyScalar: function(domID)
	{
		var multiplyScalar;
		multiplyScalar = 25;
		return multiplyScalar;
	},
	getAddScalar: function(domID)
	{
		var addScalar;
		addScalar = 25;
		return addScalar;
	},
	getAdditionalZ: function(domID)
	{
		var additionalZ;
		additionalZ = 0;
		return additionalZ;
	},
	getAdditionalX: function(domID)
	{
		var additionalX;
		additionalX = 0;
		return additionalX;
	},
	// #  Used to load colors from our server
	loadAssets: function(callback) {
		var self = this;

		if(this.colorNormal != null && this.colorHover != null && this.colorRemove != null) {
			callback();
		}
		var loader = new THREE.TextureLoader();
		loader.load('/assets/img/icons/icons8-water-96.png', function ( colorNormal ) {
			self.colorNormal = colorNormal;
			self.floodSensorNormal = colorNormal;
			loader.load('/assets/img/icons/icons8-water-hover-96.png', function ( colorHover ) {
				self.colorHover = colorHover
				self.floodSensorHover = colorHover;
				loader.load('/assets/img/icons/icons8-water-alert-96.png', function ( colorRemove ) {
					self.colorRemove = colorRemove
					loader.load('/assets/img/icons/icons8-door-sensor-96.png', function ( texture ) {
						self.doorSensorNormal = texture;
						loader.load('/assets/img/icons/icons8-smoke-detector-100.png', function ( texture ) {
							self.fireSensorNormal = texture;
							loader.load('/assets/img/icons/icons8-thermometer-automation-96.png', function ( texture ) {
								self.tempSensorNormal = texture;
								loader.load('/assets/img/icons/icons8-thermometer-automation-hover-96.png', function ( texture ) {
									self.tempSensorHover = texture;
									loader.load('/assets/img/icons/icons8-smoke-detector-hover-100.png', function ( texture ) {
										self.fireSensorHover = texture;
										loader.load('/assets/img/icons/icons8-door-sensor-hover-96.png', function ( texture ) {
											self.doorSensorHover = texture;
											loader.load('/assets/img/icons/icons8-door-sensor-alarmed-96.png', function ( texture ) {
												self.doorSensorAlert = texture;
												loader.load('/assets/img/icons/icons8-fire-alarm-box-96.png', function ( texture ) {
													self.fireSensorAlert = texture;
													loader.load('/assets/img/icons/icons8-water-alert-96.png', function ( texture ) {
														self.floodSensorAlert = texture;
														callback();
													});
												});
											});
										});
									});
								});
							});
						});
					});
				});
			});
		});
	}

});

export let sensorRenderer = new SensorRenderer();


// WEBPACK FOOTER //
// app/core/graphic_engine/controllers/SensorRenderer.js